// Module
var code = `<div class="option-analyzer-panel" {{^.visible}}style="display: none;" {{/}}>
    <div class="option-analyzer-panel-chart-container">
        <optionVolatilityLabChartRactive name="chart" terceraChartPanelContext="{{terceraChartPanelContext}}" />
    </div>
    <div class="option-analyzer-panel-settings-container {{isSettingsExpanded ? '_expanded' : '_collapsed'}}">
        <div class="option-analyzer-panel-settings-expand-collapse" on-click="expandCollapsSettings_btnClick">
            {{#if isSettingsExpanded}}
                <div class="option-analyzer-panel-settings-expand-collapse-title">
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#settings"></use>
                    </svg>
                    <terceraLabel name="settingsLabel" text="{{settingsLabel}}"/>
                </div> 
            {{/if}}
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowRight"></use>
            </svg>
        </div>
        <div class="option-analyzer-panel-settings">
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="sideLabel" text="{{sideLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control">
                    <terceraComboBox items="{{sideItems}}" selectedItem="{{selectedSideItem}}" />
                </div>
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="visibleSeriesTableLabel" text="{{visibleSeriesTableLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control _table" style="height:{{seriesTableHeight}};">
                    <quickTableRactive name="seriesTable"/>
                </div>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;